import { apiClient } from '@/lib/api-client';

export interface Receivable {
  id: string;
  saleId: string;
  customerName: string;
  customerDocType: string;
  customerDocNumber: string;
  totalAmount: string;
  paidAmount: string;
  balance: string;
  currency: string;
  status: 'OPEN' | 'SETTLED' | 'WRITTEN_OFF';
  dueDate: string | null;
  settledAt: string | null;
  createdAt: string;
  sale?: {
    id: string;
    totalAmount: string;
    paymentTerm: string;
    createdAt: string;
  };
}

export interface AgingReport {
  totalOpen: string;
  count: number;
  buckets: {
    current: string;
    d1_30: string;
    d31_60: string;
    d61_90: string;
    d90_plus: string;
  };
}

export async function listReceivables(
  opts: { status?: string; overdueOnly?: boolean; page?: number } = {},
): Promise<{ items: Receivable[]; total: number; page: number; pageSize: number }> {
  const { data } = await apiClient.get('/receivables', { params: opts });
  return data;
}

export async function getAging(): Promise<AgingReport> {
  const { data } = await apiClient.get<AgingReport>('/receivables/aging');
  return data;
}
